<template>
  <div class="Information">
    <div class="Tit">个人信息</div>
    <div class="int">
      <div class="t fl">昵称：</div>
      <div class="content fl">
        <el-input v-model="nickname" placeholder="请输入内容"></el-input>
      </div>
    </div>
    <!--<div class="int">-->
    <!--<div class="t fl">职位：</div>-->
    <!--<div class="content fl">-->
    <!--<el-select v-model="option" placeholder="请选择">-->
    <!--<el-option-->
    <!--v-for="item in options"-->
    <!--:key="item.value"-->
    <!--:label="item.label"-->
    <!--:value="item.value">-->
    <!--</el-option>-->
    <!--</el-select>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="int">-->
    <!--<div class="t fl">城市：</div>-->
    <!--<div class="content fl">-->
    <!--<el-select v-model="city" placeholder="请选择">-->
    <!--<el-option-->
    <!--v-for="item in citys"-->
    <!--:key="item.value"-->
    <!--:label="item.label"-->
    <!--:value="item.value">-->
    <!--</el-option>-->
    <!--</el-select>-->
    <!--</div>-->
    <!--</div>-->
    <div class="int">
      <div class="t fl">性别：</div>
      <div class="content fl">
        <el-select v-model="gender" placeholder="请选择">
          <el-option
            v-for="item in genders"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="int">
      <div class="t fl">个性签名：</div>
      <div class="content fl">
        <el-input v-model="signature" placeholder="请输入个性签名"></el-input>
      </div>
    </div>
    <div @click="setInfo" class="sure">确认</div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        nickname: '',
        genders: [
          {
            value: 1,
            label: '男'
          },
          {
            value: 2,
            label: '女'
          }
        ],
        option: '',
        city: '',
        gender: '',
        signature: '',
        avatar: ''
      }
    },
    created () {
      this.getUserinfo()
    },
    methods: {
      getUserinfo () {
        this.$http.post('/apipx/Personal/info', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.nickname = res.data.username
            this.signature = res.data.signature
            this.avatar = res.data.avatar
            this.gender = res.data.sex
          }
        })
      },
      setInfo () {
        this.$http.post('/apipx/Personal/setinfo', {
          sex: this.gender,
          username: this.username,
          avatar: this.avatar,
          signature: this.signature,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.getUserinfo()
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .Information {
    .Tit {
      width: 890px;
      height: 69px;
      line-height: 69px;
      font-size: 24px;
      border-bottom: 1px solid #ebebeb;
      font-weight: bold;
    }

    .int {
      margin: 20px 0 0 0;
      overflow: hidden;

      .t {
        width: 80px;
        text-align: right;
        font-size: 16px;
        height: 42px;
        line-height: 42px;
      }

      .content {
        width: 300px;
        height: 40px;
        border: 1px solid #c6c6c6;
        margin: 0 0 0 20px;
        border-radius: 5px;

        .el-input__inner {
          border: 0;
          width: 300px;
        }
      }
    }

    .sure {
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 300px;
      border-radius: 5px;
      color: #fff;
      font-size: 14px;
      background-color: #ff8484;
      margin: 50px 0 0 100px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/Information/Information.vue